<template>
  <div class="modal-window large split active">
    <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <form @submit.prevent="handleSubmit">
        <div class="grid-x split">
          <div class="cell large-6 flex-column">
            <div class="modal-window-header gray">
              <div class="modal-window-heading">
                <h3 class="icon-heading small">
                  <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-object"></use></svg></span>
                  <span class="icon-heading-title">
                    <span class="title">Opprett faktura</span>
                  </span>
                </h3>
              </div>
            </div>

            <div class="modal-window-body">
              <fieldset>
                <div class="grid-x grid-padding-x">
                  <div class="cell medium-12">
                    <template v-if="isAccounting">
                      <label for="Fakturadato">Fakturadato</label>
                      <div class="input-container">
                        <b-datepicker
                          :show-week-number="false"
                          :editable="false"
                          :first-day-of-week="1"
                          v-model="form.Fakturadato"
                          name="Fakturadato"
                          placeholder="Vis kalender..."
                          icon="calendar-today"
                          ref="Fakturadato"
                          id="Fakturadato">
                          <button class="button disabled" v-if="!form.Fakturadato"
                                  @click.prevent="$refs.Fakturadato.toggle()"><span>Slett dato</span></button>
                          <button class="button" v-else @click.prevent="form.Fakturadato = null"><span>Slett dato</span>
                          </button>
                        </b-datepicker>
                        <span class="glyph"><svg viewBox="0 0 44 44"><use
                          xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                      </div>
                    </template>

                    <label for="Forfallsdato">Forfallsdato</label>
                    <div class="input-container">
                      <b-datepicker
                        :show-week-number="false"
                        :editable="false"
                        :first-day-of-week="1"
                        :min-date="minDate"
                        v-model="form.Forfallsdato"
                        name="Forfallsdato"
                        placeholder="Vis kalender..."
                        icon="calendar-today"
                        ref="Forfallsdato"
                        id="Forfallsdato">
                        <button class="button disabled" v-if="!form.Forfallsdato" @click.prevent="$refs.Forfallsdato.toggle()"><span>Slett dato</span></button>
                        <button class="button" v-else @click.prevent="form.Forfallsdato = null"><span>Slett dato</span></button>
                      </b-datepicker>
                      <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                    </div>
                  </div>

                  <TheSelectInput containerClassName="cell medium-12" label="Type Group" name="TypeOfSaleId" required v-validate="'required'" data-vv-validate-on="input" v-model="form.TypeOfSaleId" :items="typeGroupDropdown">
                    <span slot="option" slot-scope="props">
                      {{props.option.val}}
                      <span v-if="props.option.key !== null">({{props.option.AccountId}})</span>
                    </span>
                  </TheSelectInput>
                </div>
              </fieldset>
            </div>

            <div class="modal-window-footer">
              <div class="grid-x">
                <div class="cell align-right">
                  <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
                  <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

                  <template>
                    <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Opprett faktura</a>
                    <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Opprett faktura</a>
                    <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Oppretter faktura...<span class="loader-spinner"></span></a>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="cell large-6 flex-column">
            <div class="modal-window-body">
              <div class="grid-x grid-padding-x">
                <div class="cell medium-12">
                  <h3>Selger: {{innlevav.full_name}}</h3>
                </div>
              </div>
              <div class="grid-x grid-padding-x"><div class="cell medium-12">&nbsp;</div></div>

              <div class="grid-x grid-padding-x">
                <div class="cell medium-10">
                  Fakturadresse
                </div>
                <div class="cell medium-2 align-right">
                  <span v-if="invoiceAddress">Ok</span>
                  <span v-else>X</span>
                </div>
                <div class="cell medium-12">
                  {{innlevav.full_address_fak}}
                </div>
              </div>
              <div class="grid-x grid-padding-x"><div class="cell medium-12">&nbsp;</div></div>

              <div class="grid-x grid-padding-x">
                <div class="cell medium-10">
                  Leveringsadresse
                </div>
                <div class="cell medium-2 align-right">
                  <span v-if="postAddress">Ok</span>
                  <span v-else>X</span>
                </div>
                <div class="cell medium-12">
                  {{innlevav.full_address_lev}}
                </div>
              </div>
              <div class="grid-x grid-padding-x"><div class="cell medium-12">&nbsp;</div></div>

              <div class="grid-x grid-padding-x">
                <div class="cell medium-10">
                  Kontonummer
                </div>
                <div class="cell medium-2 align-right">
                  <span v-if="accountNumber">Ok</span>
                  <span v-else>X</span>
                </div>
                <div class="cell medium-12">
                  {{innlevav.Kontonr}}
                </div>
              </div>
              <div class="grid-x grid-padding-x"><div class="cell medium-12">&nbsp;</div></div>

              <div class="grid-x grid-padding-x">
                <div class="cell medium-12">
                  <a href="javascript:;" @click="openKundeModal()">Rediger selger</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
        </a>
      </form>
    </overlay-scrollbars>
  </div>
</template>

<script>
import ObjektService from '@/services/ObjektService'
import TheAutoCompleteInput from '../Inputs/TheAutoCompleteInput'
import moment from 'moment'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktObjektTabSelgerBilagModal',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInput
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    objekt: {
      type: Object,
      required: true
    },
    objektlist: {
      type: Array,
      required: true
    }
  },
  data () {
    const today = new Date()

    return {
      form: {
        Fakturadato: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        Forfallsdato: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 10),
        TypeOfSaleId: null
      },
      innlevav: {},
      // minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      loadingKunde: false
    }
  },
  created () {
    bus.$off('kunde-address-updated')

    this.innlevav = this._.cloneDeep(this.objekt.innlevav)

    this.setFormLoading(true)
    this.fetch()
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()

    bus.$on('kunde-address-updated', (data) => this.onKundeAddressUpdated(data))
  },
  computed: {
    isAccounting: function () {
      return this.hasAccess('accounting')
    },
    minDate: function () {
      const today = new Date()

      return this.isAccounting ? null : new Date(today.getFullYear(), today.getMonth(), today.getDate())
    },
    invoiceAddress: function () {
      if (!this.innlevav) {
        return null
      }

      if (!this.innlevav.kundeadresse || this.innlevav.kundeadresse.length < 1) {
        return null
      }

      return this.innlevav.kundeadresse.filter(i => i.Type === 'faktura')
    },
    postAddress: function () {
      if (!this.innlevav) {
        return null
      }

      if (!this.innlevav.kundeadresse || this.innlevav.kundeadresse.length < 1) {
        return null
      }

      return this.innlevav.kundeadresse.filter(i => i.Type === 'levering')
    },
    accountNumber: function () {
      if (!this.innlevav) {
        return null
      }

      if (!this.innlevav.Kontonr) {
        return null
      }

      if (!this.innlevav.Kontonr.match(/^\d+$/)) {
        return null
      }

      if (!this.innlevav.Kontonr.length === 11) {
        return null
      }

      return this.innlevav.Kontonr
    },
    isValidForSave: function () {
      if (!this.innlevav.Kundenr) {
        return false
      }

      if (!this.invoiceAddress || !this.postAddress || !this.accountNumber) {
        return false
      }

      return true
    }
  },
  methods: {
    fetch: function () {
      // Load type groups
      this.typeGroupDropdown = []
      this.typeGroupDropdown.push({ key: null, val: 'Laster...' })

      ObjektService.getObjektBilagOptions(this.objekt.Objektid)
        .then((response) => {
          if (response.data.typeGroups) {
            this.typeGroupDropdown = []
            this.typeGroupDropdown.push({ key: this.form.TypeOfSaleId, val: 'Velg Type Group', disabled: true })

            response.data.typeGroups.forEach(i => {
              this.typeGroupDropdown.push({ key: i.Id, val: i.Name, AccountId: i.AccountId })
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .then(() => {
          this.setFormLoading(false)
        })
    },
    onKundeAddressUpdated: function (data) {
      this.$helpers.showSuccessAlert('Selger er lagret')

      this.innlevav = Object.assign({}, this.innlevav, data)

      let item = this._.cloneDeep(this.objekt)
      item.innlevav = Object.assign({}, item.innlevav, data)

      // Send event to root - to update kunde, as objekt->innlevav is same as kunde
      bus.$emit('kunde-merged', item.innlevav)

      // Send event to root - to update objekt
      bus.$emit('kunde-kontrakt-objekt-updated', item)
    },
    openKundeModal: function () {
      this.openModal(
        'kunde-adresse-modal',
        {
          kunde: this.objekt.innlevav,
          event: 'kunde-address-updated'
        }
      )
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    },
    submitButtonClick: function () {
      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      console.log('Save')

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.$helpers.showErrorAlert('Feil', 'Vennligst korriger feil')
            this.setFormProcessing(false)
          } else if (!this.isValidForSave) {
            this.$helpers.showErrorAlert('Feil', 'Vennligst korriger feil')
            this.setFormProcessing(false)
          } else {
            console.log('Do save')

            let post = {
              Fakturadato: this.isAccounting && this.form.Fakturadato ? moment(new Date(Date.parse(this.form.Fakturadato))).format('YYYY-MM-DD 00:00:00') : null,
              Forfallsdato: this.form.Forfallsdato ? moment(new Date(Date.parse(this.form.Forfallsdato))).format('YYYY-MM-DD 00:00:00') : null,
              TypeOfSaleId: this.form.TypeOfSaleId,
              Bilagstype: this.data.Bilagstype,
              Export: this.data.Export,
              Mvafri: this.data.Mvafri,
              Retur: this.data.Retur,
              objektlist: this.objektlist,
              type: 'normal'
            }

            console.log(post)
            console.log(JSON.stringify(post))

            ObjektService.saveObjektBilagSeller(this.objekt.Objektid, post)
              .then((response) => {
                console.log('Response')
                console.log(response)
              })
              .catch((e) => {
                console.log('Error From API')
                console.log(e)
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabSelgerBilagModal.vue